export const statusOptions = {
    CREATED: {
        colorPallet: 'wab',
        color: 'grey30',
        icon: 'PlusIcon',
    },
    ONGOING: {
        colorPallet: 'wab',
        color: 'grey50',
        icon: 'ClockIcon',
    },
    CLOSED: {
        colorPallet: 'status',
        color: 'danger',
        icon: 'CrossIcon',
    },
    PURCHASED: {
        colorPallet: 'status',
        color: 'warning',
        icon: 'CoinsIcon',
    },
    OFFSET_FROM_ANOTHER_VENDOR: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
    CONTRIBUTED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
    USER_CONTRIBUTED: {
        colorPallet: 'status',
        color: 'success',
        icon: 'CheckIcon',
    },
};
